import { typography } from "@src/core/styles";
import styled from "styled-components";

export const TitleText = styled.h1`
  ${typography.display_large};
`;

export const DescriptionText = styled.div`
  ${typography.body_large_regular};
  margin-bottom: 36px;
`;
